import React, { Suspense, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';

import { redirectToLegalConsentPage } from '@/globalFunction';
import { API_ERROR_REASON_REQUIRED_CONSENT } from '@/lib/axios/api.const';
import { AccountingConnectErrorToast } from './AccountingConnectErrorToast';
import App from './app';
import { PAGE_ROUTES } from './app/Config';
import NetworkChecker from './internetChecker';
import ContactSupport from './Modal/ContactSupport/ContactSupport';
import ScreenLoader from './screenLoader';
import useAppSocketSubscriptions from './useAppSocketSubscriptions';

import Spinner from '../common/Elements/Spinner/Spinner';
import ToastContainer from '../common/Toast/ToastContainer';

@connect((store) => {
  return {
    user: store.loggedUser.data,
    reminder: store.reminder,
  };
})
class Main extends React.Component {
  render() {
    // Forward iframeCache and setIframeCache props to App
    const { iframeCache, setIframeCache } = this.props;
    return (
      <React.Fragment>
        <Suspense fallback={<Spinner />}>
          <Router>
            <AccountingConnectErrorToast />
            <Switch>
              {Object.keys(PAGE_ROUTES).map((routeKey) => {
                const route = PAGE_ROUTES[routeKey];
                return (
                  <Route
                    key={routeKey}
                    exact={route.exact}
                    path={route.path}
                    component={route.component}
                  />
                );
              })}
              <Route>
                <App
                  iframeCache={iframeCache}
                  setIframeCache={setIframeCache}
                />
              </Route>
            </Switch>
            <ContactSupport />
          </Router>
        </Suspense>
        <ToastContainer />
      </React.Fragment>
    );
  }
}

const allowedPagesWithoutConsent = [
  PAGE_ROUTES.requestConsent.path,
  `${PAGE_ROUTES.legalInformation.path}/terms-and-conditions`,
  `${PAGE_ROUTES.legalInformation.path}/privacy-policy`,
  `${PAGE_ROUTES.legalInformation.path}/cookie-preferences`,
];

const withHooks = (Component) => (props) => {
  useAppSocketSubscriptions();

  const loggedUserData = useSelector((state) => state.loggedUser.data);
  const currentLocationHash = window.location.hash;

  useEffect(() => {
    const isCurrentLocationAllowed = !!allowedPagesWithoutConsent.find(
      (allowedPage) => currentLocationHash.includes(allowedPage)
    );
    if (
      !isCurrentLocationAllowed &&
      !loggedUserData.status &&
      loggedUserData.reason === API_ERROR_REASON_REQUIRED_CONSENT
    ) {
      redirectToLegalConsentPage();
    }
  }, [currentLocationHash, loggedUserData]);

  return <Component {...props} />;
};

export default NetworkChecker(ScreenLoader(withHooks(Main)));
